import { Button, Modal, Text } from '@inflearn/ds-react';

import { URLS } from '../../../utils/urls';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  required?: boolean;
};

const LoginRequestModal = ({ isOpen, onClose, required }: Props) => {
  const signinUrl = `${URLS.SIGNIN}?referUrl=${
    typeof window !== 'undefined' ? window.location.href : ''
  }`;

  return (
    <Modal.Root
      id="request-login"
      onClose={onClose}
      opened={isOpen}
      size="xs"
      closeOnEscape={required !== undefined ? !required : true}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header css={{ marginBottom: '8px' }}>
          <Modal.Title>로그인이 필요한 요청입니다.</Modal.Title>
        </Modal.Header>
        <Modal.Body css={{ marginBottom: '16px' }}>
          <Text>로그인 후 이용해주세요.</Text>
        </Modal.Body>
        <Modal.Footer grow>
          <Button size="md" variant="default" onClick={onClose}>
            취소
          </Button>
          <Button component="a" color="blue.6" size="md" href={signinUrl}>
            로그인
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
export default LoginRequestModal;
